import { Component, OnInit ,Input, Output,EventEmitter} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TableFilter } from '@app/shared/models/table-filter';

@Component({
  selector: 'show-entries',
  templateUrl: './show-entries.component.html',
  styleUrls: ['./show-entries.component.css']
})
export class ShowEntriesComponent implements OnInit {
  @Input() list;
  @Output() data: any = new EventEmitter<any>();

  public entryList: any = [10, 20, 40, 60, 80, 100];

  public selectedEntry:number=10;
  public routeParams;

  constructor(private router:Router,private _activeRouter:ActivatedRoute) { }

  ngOnInit() {
    this._activeRouter.queryParams.subscribe((params)=>{
      this.selectedEntry=params.limit ? params.limit : 10;
      this.routeParams=params;
    })
  }


  selectedData(e){
    this.data.emit(e);
    
    this.router.navigate([], { 
      queryParams: { page: 1,limit:e} ,
      queryParamsHandling: 'merge',
    });

  }
}
